module.exports = __webpack_public_path__ + "files/df03f91fa20b1d58eb050847874d239c.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/roboto-bolditalic-webfont.svg
 ** module id = 998
 ** module chunks = 0
 **/